import { useTranslation } from 'react-i18next';
import { Field, InjectedFormProps, reduxForm } from 'redux-form';

import Button, { ButtonType } from 'inquiry/components/Button';
import { Input, TextArea } from 'inquiry/components/FormControl';
import { EMAIL_ADDRESS_REGEX } from 'lib/constants/regexes';
import { isRequired, matchesRegexp, withMessage } from 'lib/utils/formValidation';
import FormGroup from 'verify/components/FormGroup';
import PositionableButtonContainer from 'verify/components/PositionableButtonContainer';

const validate = {
  email: [
    withMessage('The email you entered is not valid', matchesRegexp(EMAIL_ADDRESS_REGEX)),
    withMessage('Enter your email address', isRequired),
  ],
  name: withMessage('Please enter your name', matchesRegexp(/..+/)),
};

function FormSupportTicket(props: InjectedFormProps<{}, {}>) {
  const { handleSubmit, pristine, submitting } = props;

  const [t] = useTranslation();

  return (
    <form onSubmit={handleSubmit}>
      <FormGroup>
        <label htmlFor='name'>{t('support-prompt.name-label')}</label>
        <Field
          name='name'
          component={Input}
          autoComplete='name'
          disabled={submitting}
          type='text'
          placeholder={t('support-prompt.name')}
          validate={validate.name}
        />
      </FormGroup>

      <FormGroup>
        <label htmlFor='email-address'>{t('support-prompt.email-address-label')}</label>
        <Field
          name='email-address'
          component={Input}
          autoComplete='email'
          disabled={submitting}
          type='email'
          placeholder='you@example.com'
          validate={validate.email}
        />
      </FormGroup>
      <Field
        name='comment'
        component={TextArea}
        disabled={submitting}
        type='text'
        rows={5}
        placeholder={t('support-prompt.comment')}
      />

      <PositionableButtonContainer>
        <Button
          type='submit'
          buttonType={ButtonType.Primary}
          disabled={pristine || submitting}
          isPending={submitting}
        >
          {t('support-prompt.btn-submit')}
        </Button>
      </PositionableButtonContainer>
    </form>
  );
}

export default reduxForm<{}, {}>({
  form: 'support-ticket',
})(FormSupportTicket);
